import { Button, PageHeader } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import ContraVoucherListView from '../../components/account/contra/ContraVoucherListView'
import GeneralVoucherListView from '../../components/account/general/GeneralVoucherListView'
import JournalVoucherListView from '../../components/account/journal/JournalVoucherListView'


const GeneralVoucherList = () => {
  return (
    <div className='inside-main-content'>

      {/* <AdminBreadCrumb /> */}

        <div className="box-style" >
            <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="General Voucher List"
            subTitle=""
            extra={[
                <Link to={`/generalvoucher/entry`} key="reg_list">
                    <Button key="1" shape='round' className='custom-button-white'> Add</Button>
                </Link>

            
            ]}
            >

            </PageHeader>


            <div className='tableView'>
                        <div className="form-content">
                          <GeneralVoucherListView />
                        </div>
                    </div>

            

        </div>
    </div>
  )
}

export default GeneralVoucherList